<template>
  <a-modal modal-id="user-filters-modal">
    <div slot="title">Save filters</div>
    <div slot="form">
      <div class="row">
        <div>
          <label>Name</label>
          <input type="text" v-model="fData.name" class="form-control" placeholder="Name">
        </div>
        <div class="m-t-sm">
          <label>Path</label>
          <input type="text" v-model="fData.path" class="form-control" disabled>
        </div>
        <div class="m-t-sm">
          <label>Filters</label>
          <ul v-for="(f, i) in fData.filters" :key="i">
            <div v-if="i === 'stats'">
              <div v-if="Object.values(Object.values(fData.filters.stats)).reduce((a, b, i) => a + b.length, 0) !== 0">
                Stats:
                <ul v-for="(val, i) in fData.filters.stats" :key="i">
                  <li v-if="val.length !== 0">{{ i }} : {{ val }}</li>
                </ul>
              </div>
            </div>
            <div v-else>
              <li v-if="i === 'clients'">Clients: {{ getNameFromIdList(i, f) }}</li>
              <li v-else-if="i === 'groups'">Groups: {{ getNameFromIdList(i, f) }}</li>
              <li v-else-if="i === 'orders'">Orders: {{ getNameFromIdList(i, f) }}</li>
              <li v-else-if="i === 'registrars'">Registrars: {{ getNameFromIdList(i, f) }}</li>
              <li v-else-if="i === 'hosting'">Hosting: {{ getNameFromIdList('hosts', f) }}</li>
              <li v-else>{{ i }}: {{ Array.isArray(f) ? f.join() : f.label ? f.label : f }}</li>
            </div>
          </ul>
        </div>
        <div class="m-t-md">
          <a class="row btn" data-toggle="collapse" href="#collapsDynamicListName" role="button" aria-expanded="false"
          aria-controls="collapseStats">
            Create list from filters
            <i class="fa fa-chevron-down btn-sm expand-show"></i>
            <i class="fa fa-chevron-up btn-sm expand-hide"></i>
          </a>
          <div class="collapse" id="collapsDynamicListName">
            <label>List Name:</label>
            <input type="text" class="form-control" v-model="dynamicListName">
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button class="btn btn-success btn-sm" :disabled="!dynamicListName.length" @click="saveList">Save List</button>
      <button class="btn btn-primary btn-sm" @click="save()">Save Filters</button>
    </div>
  </a-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import { Query } from '../../../../../mixins/helperMixin'

export default {
  data () {
    return {
      fData: {},
      dynamicListName: ''
    }
  },
  mixins: [Query],
  computed: {
    ...mapGetters({
      user: 'getUser',
      f: 'getFilters'
    })
  },
  props: ['filterData'],
  watch: {
    filterData (data) {
      this.fData = {
        name: data.name,
        path: data.path,
        filters: this.removeEmptyFilterVals(data.filters)
      }
    }
  },
  mounted () {
    this.fData = {...this.filterData}
  },
  methods: {
    removeEmptyFilterVals (filterObj) {
      let stats = Object.fromEntries(Object.entries(filterObj.stats).filter(([k, v]) => typeof v === 'number' || v.length > 0))

      let resultObj = Object.fromEntries(Object.entries(filterObj).filter(([k, v]) => (v !== null && v !== undefined) && ((typeof v === 'number') || (v.length > 0))))

      if (Object.values(stats).length) {
        resultObj.stats = stats
      }
      return resultObj
    },
    async save () {
      if (!this.fData.name || this.fData.name.length < 3) {
        this.$toastr.error('Please name the filter')
        return
      }
      if (this.f.userData.filters.map(f => f.name).includes(this.fData.name)) {
        this.$toastr.warning('Given filter name is already used!', 'Please pick another one')
        return
      }
      if (!this.isFiltersSelected()) {
        this.$toastr.error('Please select some filters first')
        return
      }
      try {
        await this.$store.dispatch('postUserFilter', this.fData)
        this.$toastr.success('Filter saved')
        $('#user-filters-modal').modal('hide')
        this.fData = {}
        await this.$store.dispatch('loadFilters')
      } catch (e) {
        this.$toastr.error('Unable to save the filter')
      }
    },
    saveList () {
      if (!this.isFiltersSelected()) {
        this.$toastr.error('Please select some filters first')
        return
      }

      let data = {
        name: this.dynamicListName,
        filters: this.fData.filters
      }
      console.log(data)
      // send post request here
    },
    getNameFromIdList (type, idList) {
      let nameList = []
      idList.forEach((id) => {
        if (type === 'groups') {
          let groupName = this.f.groups.filter(c => c.id === id).map(c => c.name).join()
          let clientName = this.f.groups.filter(c => c.id === id).map(c => c.client.name).join()
          nameList.push(clientName + '-' + groupName)
        } else {
          let name = this.f[type].filter(c => c.id === id).map(c => c.name).join()
          nameList.push(name)
        }
      })
      return nameList.join(', ')
    },
    isFiltersSelected () {
      let nullCount = 0
      Object.values(this.fData.filters).forEach((element) => {
        if (element === null || (Array.isArray(element) && element.length === 0) || (typeof element === 'object' && Object.values(element).length === 0)) {
          nullCount += 1
        }
      })

      if (nullCount === Object.values(this.fData.filters).length) {
        return false
      }
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Build/Filters/FiltersModal.vue